import { useEffect, useState } from 'react';
import { SiteLink as Link } from './SiteLink';
import { getAnalyticsConsent, setAnalyticsConsent } from '../services/analytics';

export const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(() => getAnalyticsConsent() === null);

    useEffect(() => {
        const openSettings = () => setIsVisible(true);
        window.addEventListener('nurvo:cookie-settings', openSettings);
        return () => window.removeEventListener('nurvo:cookie-settings', openSettings);
    }, []);

    if (!isVisible) return null;

    const choose = (consent: 'granted' | 'denied') => {
        setAnalyticsConsent(consent);
        setIsVisible(false);
    };

    return (
        <aside
            aria-label="Analytics cookie choices"
            className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-3xl rounded-2xl border border-white/15 bg-background/95 p-5 shadow-2xl backdrop-blur-xl sm:bottom-5 sm:p-6"
        >
            <div className="flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
                <p className="max-w-xl text-sm leading-6 text-text-secondary">
                    We use optional analytics cookies to understand how the website is used. You can accept or reject them; essential site features still work either way.{' '}
                    <Link to="/cookies" className="font-semibold text-white underline decoration-primary underline-offset-4">Cookie details</Link>
                </p>
                <div className="flex shrink-0 gap-3">
                    <button type="button" className="button-secondary flex-1 px-4 py-2.5 sm:flex-none" onClick={() => choose('denied')}>Reject</button>
                    <button type="button" className="button-primary flex-1 px-4 py-2.5 sm:flex-none" onClick={() => choose('granted')}>Accept</button>
                </div>
            </div>
        </aside>
    );
};
